import { AdvertisementAPI } from "./advertisement";
import { AppUpdateAPI } from "./appUpdate";
import { AdminAttendanceAPI } from "./attendance";
import { CafeAPI } from "./cafe";
import { CouponAPI } from "./coupon";
import { FaqAPI } from "./faq";
import { GameInspectionScheduleAPI } from "./gameInspectionSchedule";
import { PubGradeApi } from "./pub-grade";
import { TournamentAPI } from "./tournament";
import { UserAPI } from "./user";
import { YoutubeAPI } from "./youtube";
import { ClubRewardAPI } from "./club-reward";
import { RunnerCompetitionAPI } from "./runner-competition";
import { ImagePopupAPI } from "./image-popup";
import { SolutionAdVideoAPI } from "./solution-ad-video";
import { NoticeAPI } from "./notice";

const AdminAPI = {
  ...NoticeAPI,
  ...CafeAPI,
  ...FaqAPI,
  ...TournamentAPI,
  ...UserAPI,
  ...AdvertisementAPI,
  ...YoutubeAPI,
  ...AppUpdateAPI,
  ...CouponAPI,
  ...AdminAttendanceAPI,
  ...PubGradeApi,
  ...GameInspectionScheduleAPI,
  ...ClubRewardAPI,
  ...RunnerCompetitionAPI,
  ...ImagePopupAPI,
  ...SolutionAdVideoAPI,
};
export default AdminAPI;
